<template>
    <div ref="vueCalDiv">
        <vue-cal
            style="height: 650px"
            default-view="week"
            :min-date="minDate"
            :max-date="maxDate"
            :events="events"
            locale="de"
            :on-event-click="openEventDialog"
            v-on:ready="calendarReady($event)"
            v-on:view-change="onViewChange($event)"
        >
        </vue-cal>


        <sweet-modal ref="eventModal">
            <h4 class="card-title mb-3">{{ activeEvent.title }}</h4>

            <div v-if="activeEvent.images.length">
                <img :src="activeEvent.images[0]" style="max-width: 400px" :alt="activeEvent.title" class="img-thumbnail mx-auto d-block img-fluid mb-2">
            </div>


            <h5 class="card-title">
                Beschreibung:
            </h5>
            <i>{{ activeEvent.description.length > 0 ? activeEvent.description : 'Keine Beschreibung vorhanden' }}</i>

            <h5 class="card-title mt-3">
                Details:
            </h5>
            <strong>Event-Start: </strong> {{ activeEvent.start_localized }}<br>
            <strong>Event-Ende: </strong> {{ activeEvent.end_localized }}<br>
            <strong>Kategorie: </strong> {{ activeEvent.category_name }}

            <hr>
            <h5 class="card-title mt-3">
                Aktionen
            </h5>
            <a :href="activeEvent.action_urls.show" target="_blank" class="btn btn-outline-primary">
                <i class="fa fa-eye"></i>
            </a>
            <a :href="activeEvent.action_urls.edit" target="_blank" class="btn btn-outline-warning">
                <i class="fa fa-pen"></i>
            </a>
        </sweet-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'
    import  'vue-cal/dist/i18n/de';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    Vue.use(Loading);

    import { SweetModal } from 'sweet-modal-vue';

    export default {
        name: "agenda-calendar-view",
        components: {VueCal, SweetModal, Loading},
        methods: {
            /**
             * Opens the Modal to show infos about the Clicked Event.
             */
            openEventDialog(event, e) {
                this.activeEvent = event;
                this.$refs.eventModal.open();
            },
            /**
             * Called whenever the view is changed.
             * @param e
             */
            onViewChange(e){
                this.loadEvents(e.startDate.toISOString(), e.endDate.toISOString());
            },

            /**
             * Called when the calendar is fully loaded.
             * @param e
             */
            calendarReady(e) {
                this.loadEvents(e.startDate.toISOString(), e.endDate.toISOString());
            },

            /**
             * Loads events between two timestamps.
             */
            loadEvents(startDate, endDate) {
                if(this.eventsInTimeSpanLoaded(startDate, endDate))
                    return false;

                let url = process.env.DASHBOARD_URL + '/api/v1/agenda/events?calendar&filter[between]=' + startDate + ',' + endDate;

                let loader = this.$loading.show({
                    container: this.$refs.vueCalDiv
                });

                axios.get(url).then((response) => {
                    this.appendEvents(response.data.data);

                    // Set earliest and latest timestamps
                    if(startDate < this.earliestTimeLoaded || this.earliestTimeLoaded === null)
                        this.earliestTimeLoaded = startDate;

                    if(endDate > this.latestTimeLoaded || this.latestTimeLoaded === null)
                        this.latestTimeLoaded = endDate;

                    loader.hide();
                }).catch((error) => {
                    loader.hide();
                    alert("Events können nicht geladen werden. Bitte Seite neu laden um es erneut zu versuchen.");
                });
            },

            /**
             * Checks if events between the given Timestamps have been loaded.
             */
            eventsInTimeSpanLoaded(startDate, endDate) {
                return startDate >= this.earliestTimeLoaded && endDate <= this.latestTimeLoaded;
            },

            /**
             * Appends events to the Event Array that are not in there yet.
             *
             * @param eventsToAppend
             */
            appendEvents(eventsToAppend) {
                eventsToAppend.forEach(event => {
                    if(this.events.filter(existingEvent => existingEvent.id === event.id).length === 0) {
                        this.events.push(event);
                    }
                })
            }
        },
        mounted() {},
        data: () => ({
            events: [],
            earliestTimeLoaded: null,
            latestTimeLoaded: null,
            activeEvent: {
                start: '',
                end: '',
                start_localized: '',
                end_localized: '',
                title: '',
                class: '',
                description: '',
                content: 'test',
                images: [],
                documents: [],
                action_urls: {
                    edit: '',
                    show: ''
                }
            }
        }),
        computed: {
            minDate () {
                let now = new Date();
                let date = new Date(now);
                date.setDate(now.getDate() - 15);
                return date;
            },
            maxDate () {
                let now = new Date();
                let date = new Date(now);
                date.setDate(now.getDate() + 15);
                return date;
            }
        }
    }
</script>

<style>
    /* Theme */
    .vuecal__menu, .vuecal__cell-events-count {background-color: #007C97;}
    .vuecal__menu button {border-bottom-color: #fff;color: #fff;}
    .vuecal__menu button.active {background-color: rgba(255, 255, 255, 0.15);}
    .vuecal__title-bar {background-color: rgba(114, 68, 136, 0.2);}
    .vuecal__cell.today, .vuecal__cell.current {background-color: rgba(240, 240, 255, 0.4);}
    .vuecal:not(.vuecal--day-view) .vuecal__cell.selected {background-color: rgba(235, 255, 245, 0.4);}
    .vuecal__cell.selected:before {border-color: rgba(114, 68, 136, 0.5);}


    /*  Category Colors */
    .vuecal__event.default      { background-color: #fff; }

    .vuecal__event.expo         { background-color: #C63939; border: 1px solid #6d6a6a; color: white; }
    .vuecal__event.course       { background-color: #DD7D3B; border: 1px solid #6d6a6a; color: white; }
    .vuecal__event.event        { background-color: #F8D104; border: 1px solid #6d6a6a; color: black; }
    .vuecal__event.market       { background-color: #96BB42; border: 1px solid #6d6a6a; color: black; }
    .vuecal__event.sport        { background-color: #54A2D5; border: 1px solid #6d6a6a; color: white; }
    .vuecal__event.inauguration { background-color: #E484AD; border: 1px solid #6d6a6a; }
    .vuecal__event.opendoor     { background-color: #BE7EE0; border: 1px solid #6d6a6a; color: white }
    .vuecal__event.invitation   { background-color: #0078B8; border: 1px solid #6d6a6a; color: white; }
    .vuecal__event.misc         { background-color: #D5D5D5; border: 1px solid #6d6a6a; color: black; }
</style>
